<div *ngIf="this.escola.premium && this.escola.visao_especialista" id="visao-especialista" class="row mb-5">
  <div class="col-12 mb-3">
    <h2 class="text-black font-size-biggest mb-0">Visão do especialista</h2>
  </div>
  <div class="col-12 mb-2 content">
    <p class="font-size-regular text-lightgray" style="white-space: pre-line">{{ this.escola.visao_especialista }}</p>
  </div>
</div>
